export function getVaStandardExportFilename(filename, fallback = 'video') {
    const rawName = (filename || fallback || '').toString();
    const baseName = rawName.replace(/\.[^/.]+$/, '') || rawName || fallback;
    const sanitizedName = baseName
        .replace(/[\\/]/g, '_')
        .trim();

    return `${sanitizedName || fallback}_VA STD.csv`;
}
